import React from "react";
import { useTranslation } from "react-i18next";
import { ModalState } from "../types";

interface TermsAgreementProps {
  agreedToTerms: {
    termsOfUse: boolean;
    privacyPolicy: boolean;
  };
  onTermsChange: (
    termType: "termsOfUse" | "privacyPolicy",
    checked: boolean,
  ) => void;
  onToggleModal: (modalKey: keyof ModalState) => void;
}

const TermsAgreement: React.FC<TermsAgreementProps> = ({
  agreedToTerms,
  onTermsChange,
  onToggleModal,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <h3 className="mt-[32px] mb-[16px] text-[16px] text-black/50">
        {t("onboarding.intro.terms_agreement_title")}
      </h3>

      <div className="space-y-4 my-[32px]">
        {/* Terms of Use Checkbox */}
        <div className="flex items-center">
          <input
            type="checkbox"
            id="termsOfUseCheckbox"
            checked={agreedToTerms.termsOfUse}
            onChange={(e) => onTermsChange("termsOfUse", e.target.checked)}
            className="form-checkbox h-5 w-5 accent-black text-white rounded focus:ring-teal-500 mr-4 bg-teal-500"
          />
          <span className="text-[16px]">
            {t("onboarding.intro.agree_to_sootchy")}{" "}
            <span
              onClick={() => onToggleModal("termsOfUse")}
              className="text-teal-500 hover:underline cursor-pointer"
            >
              {t("onboarding.intro.terms_of_use")}
            </span>
          </span>
        </div>

        {/* Privacy Policy Checkbox */}
        <div className="flex items-center">
          <input
            type="checkbox"
            id="privacyPolicyCheckbox"
            checked={agreedToTerms.privacyPolicy}
            onChange={(e) => onTermsChange("privacyPolicy", e.target.checked)}
            className="form-checkbox h-5 w-5 accent-black text-white rounded focus:ring-teal-500 mr-4 bg-teal-500"
          />
          <span className="text-[16px]">
            {t("onboarding.intro.agree_to_sootchy")}{" "}
            <span
              className="text-teal-500 hover:underline cursor-pointer"
              onClick={() => onToggleModal("privacyPolicy")}
            >
              {t("onboarding.intro.privacy_policy")}
            </span>
          </span>
        </div>

        {/* Cookie Policy Checkbox */}
        {/* <div className="flex items-center">
          <input
            type="checkbox"
            id="cookiePolicyCheckbox"
            checked={agreedToTerms.cookiePolicy}
            onChange={(e) => onTermsChange("cookiePolicy", e.target.checked)}
            className="form-checkbox h-5 w-5 accent-black text-white rounded focus:ring-teal-500 mr-4 bg-teal-500"
          />
          <div className="flex items-center text-[16px]">
            <span>{t("onboarding.intro.agree_to_sootchy")}</span>
            <span
              className="text-teal-500 hover:underline cursor-pointer mx-1"
              onClick={() => onToggleModal("cookiePolicy")}
            >
              {t("onboarding.intro.cookie_policy")}
            </span>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default TermsAgreement;
